<template>
  <v-navigation-drawer
    stateless
    :value="true"
    absolute
    clipped
    left
    :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    mini-variant
    mini-variant-width="60"
  >
    <v-list nav>
      <!-- <v-list-item class="pt-3">
        <v-btn
          color="transparent"
          fab
          small
          elevation="0"
          class="ml-0"
          @click="setSelectedPageId(null)"
        >
          <c-icon
            icon="context"
            :color="!selectedPageId ? 'blue darken-1' : 'grey lighten-1'"
            size="22"
          ></c-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider> -->
      <v-list-item class="pt-2">
        <v-btn
          :color="show == 'outline' ? 'primary' : 'transparent'"
          fab
          small
          elevation="0"
          class="ml-0"
          @click="$emit('toggleSidebar', 'outline')"
        >
          <!-- <v-avatar size="38" color="primary"> -->
          <v-icon>toc</v-icon>
          <!-- </v-avatar> -->
        </v-btn>
      </v-list-item>
      <v-list-item>
        <v-btn
          :color="show == 'research' ? 'primary' : 'transparent'"
          fab
          small
          elevation="0"
          class="ml-0"
          @click="$emit('toggleSidebar', 'research')"
        >
          <!-- <v-avatar size="38" color="primary"> -->
          <v-icon>receipt</v-icon>
          <!-- </v-avatar> -->
        </v-btn>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  components: {},
  props: ['show'],
  data() {
    return {};
  },
  computed: {
    ...mapState('views/context', ['selectedPageId']),
    ...mapGetters('context', ['userCanEdit', 'userIsWorkspaceMember', 'context'])
  },
  methods: {
    ...mapMutations('views/context', ['setSelectedPageId'])
  }
};
</script>

<style></style>
